import { useGetPackagingsSearch } from "@/pages/packaging/usePackagings";
import { Select, SelectProps } from "antd";
import { useState, useMemo } from "react";

export default function PackagingSelector(props: SelectProps) {
  const [search, setSearch] = useState<string | undefined>(undefined);

  const { data, isLoading, fetchNextPage, hasNextPage } = useGetPackagingsSearch({
    search,
    selectedIds: props.value as number[] | undefined,
  });

  const allPackagings = useMemo(() => {
    return data?.pages.flatMap((page) => page.data.data) || [];
  }, [data]);

  const onSearch = (value: string) => {
    if (value.trim() === "") {
      setSearch(undefined);
    } else {
      setSearch(value);
    }
  };

  const onPopupScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const { target } = e;
    if (target instanceof HTMLElement) {
      if (target.scrollTop + target.offsetHeight === target.scrollHeight && hasNextPage) {
        fetchNextPage();
      }
    }
  };

  return (
    <Select
      showSearch={true}
      onSearch={onSearch}
      style={{ width: "100%" }}
      mode="multiple"
      loading={isLoading}
      onPopupScroll={onPopupScroll}
      options={allPackagings.map((x) => ({
        key: x.id,
        value: x.id,
        label: x.label,
      }))}
      optionFilterProp="label"
      {...props}
    />
  );
}
